import { fontEndConfig } from '@/shared/utils';
/** @desc 是否可参拍 */
export function dealIsAuction(key) {
    switch (key) {
        case 1:
            return '是';
        case 0:
            return '否';
        default:
            return fontEndConfig.noValueReplace;
    }
}
/** @desc 是否本机构 */
export function dealPlatformType(key) {
    switch (key) {
        case 1:
            return '本机构';
        case 2:
            return '车易拍';
        default:
            return fontEndConfig.noValueReplace;
    }
}
